module.exports = __webpack_public_path__ + "img/nocamera.045282f0.png";